import { store } from "@app/store";
import { Button } from "@components/button";
import { EllipsisText } from "@components/ellipsis-text";
import { FlexLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { Config, DoubleText } from "@components/table";
import {
  PaymentCredited,
  PaymentNotCredited,
  PaymentProcessing,
} from "@features/appeals/components/status";
import { usePayoutOrders } from "@features/payouts";
import { OrderPayout } from "@features/payouts/api";
import {
  removeFile,
  resetOrder,
  setMessage,
  setReceipts,
} from "@features/payouts/slice";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";
import { useNotification } from "@hooks/use-notification";
import { useEffect } from "react";

type Props = {
  isOpen: boolean;
  hide: () => void;
  data: OrderPayout;
  isView: boolean;
};

export const PayOutOrderModal = ({ isOpen, hide, data, isView }: Props) => {
  const { state, uploadReceipt, payOutOrderReview, getPayoutOrders } =
    usePayoutOrders();
  const notif = useNotification();

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files == null || data.id == null) return;
    const file = event.target.files;
    uploadReceipt(data.id, file).then(() => {
      notif.addNotification("Файл добавлен");
    });
  };
  useEffect(() => {
    store.dispatch(resetOrder());
    if (data.trader_files) store.dispatch(setReceipts(data.trader_files));
  }, [data]);

  const config: Config<OrderPayout> = [
    {
      label: "Номер заявки",
      source: "id",
      renderComponent: (data) => <EllipsisText text={data} copy />,
    },
    {
      label: "Дата",
      source: "created_at_unix",
      renderComponent: (data) => (
        <div>
          {formatDate(new Date(data * 1000))}{" "}
          {formatTime(new Date(data * 1000))}
        </div>
      ),
    },
    {
      label: "Сумма",
      source: "sum",
      renderComponent: (data, item) => (
        <DoubleText
          text={formatRubles(data)}
          subText={formatUsdt(item.sum_usdt)}
        />
      ),
    },
    {
      label: "Файлы",
      source: "id",
      renderComponent: () => {
        return (
          <>
            {state.isReceiptLoading ? (
              "Загрузка..."
            ) : (
              <>
                {state.receiptUrls.map((file) => (
                  <div
                    key={file}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                  >
                    <a className="underline" href={file} target="_blank">
                      {file.split("/").pop()}
                    </a>
                    <span
                      style={{ color: "red" }}
                      onClick={() => {
                        store.dispatch(removeFile(file));
                      }}
                    >
                      ×
                    </span>
                  </div>
                ))}
                {!isView && (
                  <label style={{ cursor: "pointer" }}>
                    Добавить
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </label>
                )}
              </>
            )}
          </>
        );
      },
    },
    {
      label: "Сообщение",
      source: "id",
      renderComponent: () => (
        <textarea
          disabled={isView}
          value={state.message}
          onChange={(e) => store.dispatch(setMessage(e.target.value))}
        ></textarea>
      ),
    },
  ];
  const sendOrderData = async () => {
    // if (state.receiptUrls.length == 0) {
    //   notif.addNotification("Должны быть прикреплены фотографии чеков");
    //   return;
    // }
    const request = {
      images: state.receiptUrls,
      order: data.id,
      message: state.message,
    };
    payOutOrderReview(request).then(() => {
      hide();
      notif.addNotification("Создано!");
      getPayoutOrders({ limit: 100, page: 1, my_orders: true });
    });
  };
  return (
    <Modal isOpen={isOpen} onClose={hide} title={`✅ Заявка №${data.id}`}>
      <p>Подтверждение перевода</p>
      {isView && (
        <>
          {data.status === "completed" && (
            <PaymentCredited text="Платеж зачислен" />
          )}

          {["failed", "canceled"].includes(data.status) && (
            <PaymentNotCredited text="Платеж отменен" />
          )}

          {[
            "processing",
            "pending",
            "assigned_to_trader",
            "under_review_by_support",
          ].includes(data.status) && <PaymentProcessing text="В обработке" />}
        </>
      )}
      {state.isReviewLoading ? (
        <FlexLoader style={{ width: "200px", height: "200px" }} />
      ) : (
        <RowTable config={config} data={data} />
      )}
      {!isView && <Button onClick={() => sendOrderData()}>Отправить</Button>}
    </Modal>
  );
};
